// extracted by mini-css-extract-plugin
export default {"tabs":"Candidate_tabs__IZIqG"};